import { BaseFilterButton } from 'components/base-table/filters';
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  Stack,
  useBoolean,
  useDisclosure,
} from 'design-system';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  code: string;
};

const defaultValues: TInputs = {
  code: '',
};

export const OrderCodeFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.code) setIsActive.on();
    else setIsActive.off();
  }, [params.code]);

  const { register, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values
  const updateValues = () => {
    setValue('code', (params.code as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.code]);

  const onSubmit = (data: TInputs) => {
    params.code = data.code.trim().toString();

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <FormLabel>Code</FormLabel>
            <InputGroup size='sm'>
              <Input {...register('code')} />
            </InputGroup>
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
